import { TUserDetailsResponse } from "../types/User.type";
class SessionStorageService {
  private static _instance: SessionStorageService;

  public constructor() { }

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  public getItem(key: string) {
    const stored = sessionStorage.getItem(key);
    return (stored && JSON.parse(stored)) || null;
  }

  public setItem(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  public setUserDetails(details: any): void {
    this.setItem("token", details?.["token"] ?? "");

    if (details?.["user"]) {
      this.setItem("user", details["user"]);
    } else {
      console.warn("⚠️ No user in details");
    }
    this.setItem("account", details["account"]);
    this.setDefaultAccount(details["account"]);
  }

  public getToken(): string {
    return this.getItem("token");
  }

  public getUserRole(): string | null {
    let user = this.getItem("user");
    return user !== null ? user["role"] : null;
  }

  public setDefaultAccount(defaultAccount: {}): void {
    this.setItem("default_account", defaultAccount);
  }

  public getDefaultAccount(): {} | null {
    return this.getItem("default_account");
  }

  public clearSessionStorage(): void {
    sessionStorage.clear(); // This will remove all key-value pairs from sessionStorage
  }

  public getUserDetails(): TUserDetailsResponse | null {
    let user = this.getItem("user");
    return user;
  }
}
export const SessionSorageInstance = SessionStorageService.Instance;
